import React from 'react';
/**
 * Component to sort the children based on the `order` property.
 *
 * @example
 * <Layout order={['footer']}>
 *   <p key="footer">Settings</p>
 * </Layout>
 */
export default function Layout({ order, children }) {
    return React.createElement(React.Fragment, null, order.map((key) => children.find((child) => child?.key === key)));
}
//# sourceMappingURL=Layout.js.map